<!-- Desktop -->
<mat-toolbar class="d-none d-lg-flex flex-column p-0" [class.fixed]="hideOnScrollDown || isFixed" [class.scrolling-down]="scrollingDown && hideOnScrollDown">
  <div class="promo-banner w-100">
    <div class="d-flex align-items-center justify-content-center h-100 w-100 promo-banner">
      <span>Free Shipping on all Orders over $60</span>
    </div>
  </div>
  <div class="nav-wrapper d-flex justify-content-evenly align-items-center h-100 w-100 px-5 py-3">
    <a routerLink="/">
      <img class="nav-logo" src="/assets/images/logos/navbar-logo-design.png" alt="My Pool Hut Logo" />
    </a>
    <div class="d-flex flex-column h-100 w-100 ms-5">
      <div class="d-flex align-items-center justify-content-between h-100 w-100">
        <app-search class="w-100"></app-search>
        <div class="d-flex justify-content-between align-items-center text-center" [ngClass]="!(customer$ | async)?.firstName ? 'sign-in-wrapper' : 'profile-wrapper'">
          @if (!(customer$ | async)?.firstName) {
            <button mat-button aria-label="Sign In" class="login" (click)="openLogin()">Sign in</button>
          }
          @if ((customer$ | async)?.firstName) {
            <button mat-icon-button aria-label="Sign In" [matMenuTriggerFor]="menu" class="icon-button">
              <mat-icon
                class="material-symbols-outlined filled"
                matBadgeColor="accent"
                matBadgeSize="small"
                matTooltip="My Account">
                account_circle
              </mat-icon>
            </button>
          }
          <button mat-icon-button aria-label="Shopping Cart" (click)="openCart()"  class="icon-button">
            <mat-icon
              class="material-symbols-outlined"
              matBadgeColor="accent"
              matBadgeSize="small"
              [matBadge]="(cart$ | async)?.totalProducts"
              [matBadgeHidden]="(cart$ | async)?.lines?.length === 0 ? true : false"
              matTooltip="Cart">
              shopping_bag
            </mat-icon>
          </button>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between w-100 nav-items pt-3">
        <!-- <a class="d-lg-inline" routerLink="/"><h5 class="important">SALE</h5></a> -->
        <a class="d-lg-inline" routerLink="/pool-care"><h5>Pool Care</h5></a>
        <a class="d-lg-inline" routerLink="/hot-tub-care"><h5>Hot Tub Care</h5></a>
        <a class="d-lg-inline" routerLink="/brands"><h5>Shop By Brand</h5></a>
        <a class="d-none d-lg-inline" routerLink="/blog"><h5>Learning Center</h5></a>
        <!-- <a class="d-none d-lg-inline" routerLink="/"><h5>Contact An Expert</h5></a> -->
        <a class="d-none d-lg-inline" routerLink="/about-us"><h5>About Us</h5></a>
      </div>
    </div>
  </div>
</mat-toolbar>
<!-- Mobile -->
<mat-toolbar class="d-flex d-lg-none" [class.fixed]="hideOnScrollDown || isFixed" [class.scrolling-down]="scrollingDown && hideOnScrollDown">
  <mat-toolbar-row class="promo-banner p-0">
    <div class="d-flex align-items-center justify-content-center h-100 w-100 promo-banner">
      <span>Free Shipping on all Orders over $60</span>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row class="pt-3">
    <div class="d-flex justify-content-between w-100 align-items-center w-100">
      <div class="mt-3 px-0">
        <button class="d-block d-lg-none" mat-icon-button (click)="toggleSidenav()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <a routerLink="/">
        <img class="nav-logo" src="/assets/images/logos/navbar-logo-design.png" alt="My Pool Hut Logo" />
      </a>
      <div class="d-flex mt-3">
        @if (!(customer$ | async)?.firstName) {
          <button mat-icon-button class="icon-button" aria-label="Sign In" (click)="openLogin()">
            <mat-icon
              class="material-symbols-outlined filled"
              matBadgeColor="accent"
              matBadgeSize="small"
              matTooltip="My Account">
              account_circle
            </mat-icon>
          </button>
        }
        @if ((customer$ | async)?.firstName) {
          <button mat-icon-button class="icon-button" aria-label="Sign In" [matMenuTriggerFor]="menu">
            <mat-icon
              class="material-symbols-outlined filled"
              matBadgeColor="accent"
              matBadgeSize="small"
              matTooltip="My Account">
              account_circle
            </mat-icon>
          </button>
        }
        <button mat-icon-button class="icon-button" aria-label="Shopping Cart" (click)="openCart()">
          <mat-icon
            class="material-symbols-outlined"
            matBadgeColor="accent"
            matBadgeSize="small"
            [matBadge]="(cart$ | async)?.totalProducts"
            [matBadgeHidden]="(cart$ | async)?.lines?.length === 0 ? true : false"
            matTooltip="Cart">
            shopping_bag
          </mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row>
    <app-search class="w-100"></app-search>
  </mat-toolbar-row>
  <mat-toolbar-row class="row-sm">
    <div class="d-flex align-items-center justify-content-evenly w-100 nav-items">
      <a class="" routerLink="/pool-care"><h5>Pool Care</h5></a>
      <a class="" routerLink="/hot-tub-care"><h5>Hot Tub Care</h5></a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-menu #menu="matMenu" xPosition="before">
  <a class="" routerLink="/orders">
    <button mat-menu-item>
      <mat-icon>list_alt</mat-icon>
      <span>My Orders</span>
    </button>
  </a>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
